import { EditableTableHeader } from "./editable-table-header.interface";
import { PermissionConditionSet } from "../services/permission.service";

export interface TableMeta {
  name?: string;
  uniqueColumns?: string[],
  columns: ColumnDto[];
  actions?: ColumnDto[];
}

export interface ColumnDto {
  fieldName: string;
  displayName: string;
  hidden?: boolean;
  dataType: string;
  defaultValue?: any;
  valueMap?: {
    [key: string]: string;
  };
  linkInfo?: LinkInfo;
  sortable?: boolean,
  styleConfig?: DisplayStyleConfig
  thStyleConfig?: any
}

export interface TableMenuOption {
  label: string;
  value: string;
  condition?: (record: any) => boolean;
  requiresPermission?: PermissionConditionSet
}

export interface LinkInfo {
  url: string;
}


export enum TableDataType {
  STRING = "STRING",
  NUMBER = "NUMBER",
  BOOLEAN = "BOOLEAN",
  DATETIME = "DATETIME",
  DATE = "DATE",
  DATETIME_EPOCH = "DATETIME_EPOCH",
  ARRAY = "ARRAY",
  JSON = "JSON",
  CLICKABLE = "CLICKABLE",
}

export interface DisplayStyleConfig {
  type?: 'text' | 'badge' | 'status' | 'multi-tag' | 'user-avatar' | 'hyper-link' | string;
  icon?: string;
  iconPosition?: 'left' | 'right' | string;
  styleProperties?: any,
  iconStyleProperties?: any,
  multiTagConfig?: MultiTagConfig;
  actionConfig?: Action;
  conditions?: ConditionConfig[];
}

export interface Action {
  label: string;
  actionName: string;
  writeOperation: boolean;
  conditions?: ConditionConfig[];
}

export interface MultiTagConfig {
  labelKey?: string,
  color?: string;
  backgroundColor?: string;
  orderedValueStyles?: MultiTagValueConfig[]
}

export interface MultiTagValueConfig {
  color?: string;
  backgroundColor?: string;
  styleProperties?: any,
}

export interface ConditionConfig {
  expression: string;
  styleProperties?: any,
  iconStyleProperties?: any,
}
